<div class="wrapper-reponsive">
    <!-- Start màn 6 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-4">
        <div class="tlt-border mb-3">
            {{'STR_SELECT_RESERVATION_CATEGORY' | translate}}
        </div>
        <p class="p-2">
            {{'STR_EXPLAIN_RESERVATION_CATEGORY' | translate}}
        </p>
        <div class="text-center mt-2">
            <div class="mb-4">
                <button class="btn btn-common btn-bg-green" *ngIf="objHTOrg?.InsuranceWebRsvFlg === '1'&& objHTOrg?.ConsulIDManualAssignFlg!=='1'" (click)="OpenScreen0302()">
                    <span class="text-insurance">{{'STR_EXAMINEE_BY_HEALTH_INSURANCE' | translate}}</span>
                </button>
                <button class="btn btn-common btn-bg-green text-grey" disabled *ngIf="objHTOrg?.InsuranceWebRsvFlg === '0'||objHTOrg?.ConsulIDManualAssignFlg==='1'">
                    <span class="text-insurance">{{'STR_EXAMINEE_BY_HEALTH_INSURANCE' | translate}}</span>
                </button>
            </div>
            <div>
                <button class="btn btn-common btn-bg-yellow" *ngIf="objHTOrg?.ExpenceWebRsvFlg === '1'&& objHTOrg?.ConsulIDManualAssignFlg!=='1'" (click)="OpenScreen0303()">
                    <span class="text-insurance">{{'STR_EXAMINEE_AT_YOUR_OWN_EXPENSE' | translate}}</span>
                </button>
                <button class="btn btn-common btn-bg-yellow text-grey" disabled *ngIf="objHTOrg?.ExpenceWebRsvFlg === '0'||objHTOrg?.ConsulIDManualAssignFlg==='1'">
                    <span class="text-insurance">{{'STR_EXAMINEE_AT_YOUR_OWN_EXPENSE' | translate}}</span>
                </button>
            </div>
        </div>
        <p class="p-4">
            <span *ngIf="objHTOrg?.InsuranceWebRsvFlg === '1' && objHTOrg?.ExpenceWebRsvFlg === '0'&& objHTOrg?.ConsulIDManualAssignFlg!=='1'">{{'STR_ONLY_INSURANCE_SELECTION' | translate}}</span>
            <span *ngIf="objHTOrg?.InsuranceWebRsvFlg === '0' && objHTOrg?.ExpenceWebRsvFlg === '1'&& objHTOrg?.ConsulIDManualAssignFlg!=='1'">{{'STR_ONLY_OWN_EXPENSE_SELECTION' | translate}}</span>
            <span *ngIf="objHTOrg?.InsuranceWebRsvFlg === '0' && objHTOrg?.ExpenceWebRsvFlg === '0'||objHTOrg?.ConsulIDManualAssignFlg==='1'">{{'STR_NO_MEDICAL_EXAMINATION_SELECTION' | translate}}</span>
        </p>
    </div>
    <!-- End màn 6 -->
</div>